module.exports = __webpack_public_path__ + "img/ikon_torsk.2b887d74.svg";